import { EducatorUserService, IUser, SessionService } from "@imaginelearning/mps-api-service";
import { getCurrentDateISOString } from "./formatter";
import { logout } from "./auth-service";

export function logoutUser(user: IUser) {
  const sessionIdKey = window.STUDENT_ENV.REACT_APP_SESSION_KEYNAME as string;
  const logoutMessageKey = window.STUDENT_ENV.REACT_APP_LOGOUT_MESSAGE_KEYNAME as string;
  SessionService.logoff().then(() => {
    sessionStorage.removeItem(sessionIdKey);
    sessionStorage.setItem(logoutMessageKey, "UserLogoff");
    if (isALegacyCustomer()) {
      postLogoffRedirect();
    } else {
      sendLogoutEvent(user).finally(() => {
        logout();
      });
    }
  });
}

function isALegacyCustomer() {
  return window.location.hostname.toLowerCase().includes("edgenuity");
}

export function redirectToPss() {
  SessionService.logoff().then(() => {
    sessionStorage.clear();
    window.open(window.STUDENT_ENV.REACT_APP_PSS_URL, "_self");
  });
}

export function postLogoffRedirect() {
  sessionStorage.clear();
  window.location.replace(window.STUDENT_ENV.REACT_APP_ALA_DEFAULT_RETURN_URL); // on click of ok in logout model, return to ALA
}

export async function sendLogoutEvent(user: IUser) {
  try {
    const clientDateTime = getCurrentDateISOString();
    const { userAgent } = navigator;
    const { userId } = user;
    await EducatorUserService.studentLogoutEvent(userId, clientDateTime, userAgent);
  } catch (error) {
    console.error("Error in sending logout event", error);
  }
}
